import { createReducer } from '@reduxjs/toolkit';
import { ActionObject } from '../StoreConstants';
import { Types } from './Actions';
import INITIAL_STATE, { GlobalLoadingInitialState } from './InitialState';

const showGlobalLoading = (state: GlobalLoadingInitialState, action: ActionObject) => ({
  ...state,
  enabled: true,
});

const hideGlobalLoading = (state: GlobalLoadingInitialState, action: ActionObject) => ({
  ...state,
  ...INITIAL_STATE,
});

export const GlobalLoadingReducer = createReducer(INITIAL_STATE, {
  [Types.SHOW_GLOBAL_LOADING]: showGlobalLoading,
  [Types.HIDE_GLOBAL_LOADING]: hideGlobalLoading,
});